export const textAllCleaner = (text = '') => {
  return text.trim().replace(/\s+/g, ' ').toLowerCase();
};
